import React, { useState, useRef, useEffect } from "react";
import { Button, Form, Modal, ModalBody, Stack } from "react-bootstrap";
import DocumentScanner from "./DocumentScanner";
import { useLocation } from "react-router-dom";
import LoadingDots from "./LoadingDots";
import { getPtByMrn, SelectFullPt } from "../../Funcs/getPtByMrnFB";
import {
  myFbollection,
  firestore,
  myFbShobraregistrations,
} from "../../Utils/fbFunctionInit";
import { calculateAge } from "../../Funcs/Miscellaneous";
import { useTranslation } from "react-i18next";
import { BasicColor } from "../../Utils/constants";
import SelectImageFromDevice from "./SelectImageFromDevice";
import LoginModal from "../loginModal";
import FbPhotoGallery from "./FbDownloadFolder";
import { simpleBase62Decode } from "../../Funcs/Encryption";

const CameraCaptureButton = () => {
  const { t, i18n } = useTranslation();
  const { search } = useLocation();
  const location = useLocation();
  const params = new URLSearchParams(search);
  const sentMrn = simpleBase62Decode(params.get("mrn"));
  const [isAdmin, setIsAdmin] = useState(false);
  const [mrn, setMrn] = useState(sentMrn);
  const [imageUrl, setImageUrl] = useState(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [videoDevices, setVideoDevices] = useState([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState("");
  const [cameraActive, setCameraActive] = useState(false);
  const [useFrontCamera, setUseFrontCamera] = useState(false);
  const videoRef = useRef(null);
  const mediaStreamRef = useRef(null);
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  const [showLoadingDots, setShowLoadingDots] = useState(false);
  const [showFlash, setShowFlash] = useState(false);
  const [selectedPtData, setSelectedPtData] = useState(null);
  const [showSelectImg, setShowSelectImg] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(true);
  const [mrnReadOnly, setMrnReadOnly] = useState(true);

  const fetchData = async (ptMedRN) => {
    setShowLoadingDots(true);
    try {
      const querySnapshot = await firestore
        .collection(myFbShobraregistrations)
        .where("value.ptMedRN", "==", ptMedRN)
        .get();
      const data = querySnapshot.docs.map((doc) => doc.data())[0];
      setSelectedPtData(data.value);
      setShowLoadingDots(false);
      console.log("the data ", data);
    } catch (error) {
      console.log("fire base error", error);
    }
  };

  useEffect(() => {
    if (location.pathname === "/ptupload") {
      setShowLoginModal(false);
      fetchData(mrn);
    }
  }, []);

  useEffect(() => {
    {
      cameraActive && isIOS && document.getElementById("fileInput").click();
    }
  }, [cameraActive]);

  const stopCamera = () => {
    setShowLoadingDots(false);
    if (mediaStreamRef.current) {
      // Stop all tracks
      mediaStreamRef.current.getTracks().forEach((track) => {
        track.stop(); // Stop each track (audio, video)
      });
      // Release the media stream
      mediaStreamRef.current = null;
    }

    // If you want to clear the video feed, set the video source to null
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }

    setCameraActive(false); // Ensure UI updates to reflect camera off state
  };

  useEffect(() => {
    const handleNavigation = () => {
      if (
        location.pathname !== "/upload" ||
        location.pathname !== "/ptupload"
      ) {
        stopCamera();
      }
    };

    handleNavigation(); // Check on component mount

    return () => {
      stopCamera(); // Stop the camera if the component unmounts
    };
  }, [location]);

  useEffect(() => {
    const getCameras = async () => {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoInputs = devices.filter(
          (device) => device.kind === "videoinput"
        );
        setVideoDevices(videoInputs);
        if (videoInputs.length > 0 && !isIOS) {
          setSelectedDeviceId(videoInputs[0].deviceId);
        }
      } catch (error) {
        console.error("Error fetching devices:", error);
      }
    };
    getCameras();
  }, [isIOS]);

  useEffect(() => {
    const startCamera = async () => {
      if (cameraActive && videoRef.current) {
        try {
          const constraints = isIOS
            ? { video: { facingMode: useFrontCamera ? "user" : "environment" } }
            : {
                video: {
                  deviceId: selectedDeviceId
                    ? { exact: selectedDeviceId }
                    : undefined,
                },
              };

          const stream = await navigator.mediaDevices.getUserMedia(constraints);
          videoRef.current.srcObject = stream;
          mediaStreamRef.current = stream;
        } catch (error) {
          console.error("Camera access denied:", error);
        }
      }
    };

    if (cameraActive) startCamera();
  }, [cameraActive, selectedDeviceId, useFrontCamera, isIOS]);

  const handleFileInput = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageDataUrl = URL.createObjectURL(file);
      setCapturedImage(imageDataUrl);
    }
  };

  const captureImage = async () => {
    setShowLoadingDots(true);

    if (mediaStreamRef.current) {
      try {
        const track = mediaStreamRef.current.getVideoTracks()[0];
        const imageCapture = new ImageCapture(track);
        const blob = await imageCapture.takePhoto();
        const imageDataUrl = URL.createObjectURL(blob);
        setCapturedImage(imageDataUrl);
      } catch (error) {
        console.error("Error capturing image:", error);
      }
    }

    setShowFlash(true);
    setTimeout(() => setShowFlash(false), 200);
    const cameraSound = document.getElementById("cameraSound");
    cameraSound.play();
    stopCamera();
  };

  const styles = {
    flashOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "white",
      zIndex: 9999,
      opacity: 0.8,
      animation: "fadeOut 0.2s ease-in-out",
    },
  };

  const handleSelectLocalImage = (image) => {
    setCapturedImage(image);
  };

  return (
    <div>
      {/* Camera Selection and Start Button */}
      <h5>
        {t("MRN")}: {mrn}
      </h5>

      <Form>
        <Form.Group
          style={{
            padding: "15px",
            borderLeftColor: "#bf0af5", //0ab6f5 f5490a  bf0af5  f5490a  41f50a
            borderLeftStyle: "solid",
            borderLeftWidth: "10px",
            backgroundColor: "#d9adf4", //adecf4 f4b5ad  d9adf4  f4b5ad  c9f4ad
          }}
        >
          <Stack direction="horizontal" gap={1}>
            <Stack direction="horizontal" gap={1}>
              <Form.Label>{t("Name")}: </Form.Label>
              <Form.Control
                style={{
                  marginBottom: "10px",
                  backgroundColor: "lightyellow",
                }}
                placeholder="MRN"
                type="number"
                onChange={(event) => {
                  setSelectedPtData(null);
                  setMrn(event.target.value);
                }}
                value={mrn}
                readOnly={!isAdmin}
              />
              <Button
                disabled={!isAdmin}
                size="sm"
                variant="info"
                onClick={() => fetchData(mrn)}
              >
                {t("Go")}
              </Button>
            </Stack>
          </Stack>
        </Form.Group>
      </Form>

      {selectedPtData && (
        <table className="table">
          <thead>
            <tr>
              <th key={1}>MRN</th>
              <th key={2}>Name</th>
              <th key={3}>Gender</th>
              <th key={4}>age</th>
            </tr>
          </thead>
          <tbody>
            <tr id="personalData">
              <td key={"A" + 1}>{mrn}</td>
              <td key={"A" + 2}>{selectedPtData.ptName}</td>
              <td key={"A" + 3}>{selectedPtData.ptGender}</td>
              <td key={"A" + 4}>
                {calculateAge(selectedPtData.ptDob)[0]}y{" "}
                {calculateAge(selectedPtData.ptDob)[1]}m
              </td>
            </tr>
          </tbody>
        </table>
      )}
      {showLoadingDots && <LoadingDots />}
      {showFlash && <div style={styles.flashOverlay}></div>}
      {cameraActive && !isIOS && (
        <div>
          <Form.Group>
            <Form.Label>{t("SelectCamera")}</Form.Label>
            <Form.Control
              as="select"
              value={selectedDeviceId}
              onChange={(e) => setSelectedDeviceId(e.target.value)}
            >
              {videoDevices.map((device) => (
                <option key={device.deviceId} value={device.deviceId}>
                  {device.label || `Camera ${device.deviceId}`}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </div>
      )}
      {!cameraActive && selectedPtData && (
        <Button
          // variant="primary"
          size="sm"
          style={{ margin: "10px", backgroundColor: BasicColor }}
          onClick={() => {
            setCameraActive(true);
          }}
        >
          {t("StartCamera")}
        </Button>
      )}
      {!cameraActive && selectedPtData && (
        <Button size="sm" variant="info" onClick={() => setShowSelectImg(true)}>
          {t("SelectPhoto")}
        </Button>
      )}
      {/* Video Feed and Capture Button */}
      {cameraActive && selectedPtData && (
        <div>
          {!isIOS && (
            <video
              ref={videoRef}
              autoPlay
              style={{
                width: "100%",
                height: "auto",
                border: "1px solid black",
                marginTop: "10px",
              }}
            />
          )}
          {!isIOS && (
            <Button
              variant="success"
              onClick={captureImage}
              style={{ margin: "10px" }}
            >
              {t("CaptureImage")}
            </Button>
          )}
          <Button variant="dark" onClick={stopCamera}>
            {t("StopCamera")}
          </Button>
          {/* {isIOS ? <h1>IOS system</h1> : <h1>Not IOS</h1>} */}

          {/* iOS-specific capture method */}
          <input
            type="file"
            accept="image/*;capture=camera"
            id="fileInput"
            style={{ display: "none" }}
            onChange={handleFileInput}
          />

          {/* Toggle Button for Front/Back Camera on iOS */}
          {/* {isIOS && (
            <Button
              variant="secondary"
              onClick={() => setUseFrontCamera((prev) => !prev)}
              style={{ marginTop: "10px", marginLeft: "10px" }}
            >
              Switch to {useFrontCamera ? "Back" : "Front"} Camera
            </Button>
          )} */}
        </div>
      )}
      {/* Display DocumentScanner if an image is captured */}
      {capturedImage && (
        <div>
          {selectedPtData && (
            <DocumentScanner mrn={mrn} capturedImage={capturedImage} />
          )}
        </div>
      )}
      {selectedPtData && <FbPhotoGallery folderName={mrn} />}

      <audio id="cameraSound" src="/sounds/cameraShutter.mp3"></audio>
      <Modal show={showSelectImg} onHide={() => setShowSelectImg(false)}>
        <Modal.Header closeButton></Modal.Header>
        <ModalBody>
          <SelectImageFromDevice
            uploadFunction={(image) => handleSelectLocalImage(image)}
            handleSelfClose={() => setShowSelectImg(false)}
          />
        </ModalBody>
      </Modal>
      <LoginModal
        showThis={showLoginModal}
        getPass={(pass) => {
          if (
            pass.toLowerCase() === "asmaa" ||
            pass.toLowerCase() === "malak"
          ) {
            setIsAdmin(true);
            setShowLoginModal(false);
          }
        }}
      />
    </div>
  );
};

export default CameraCaptureButton;
